import { mapActions, mapGetters } from 'vuex';
// import {
//   getFreeMeetingCredentials,
//   getMeetingCredentials
// } from '@/api/meeting';
import { loadLanguageAsync } from '@/lang';
import { updateStatus, updateProfile } from '@/api/profile';
export default {
  data () {
    return {
      meetingInitiated: false
    };
  },
  computed: {
    ...mapGetters('AppStore', {
      bandwidth: 'bandwidth',
      loudSpeakerEnabled: 'loudSpeakerEnabled',
      micMuted: 'micMuted',
      pipEnabled: 'pipEnabled',
      speakerMuted: 'speakerMuted',
      videoEnabled: 'videoEnabled'
    }),
    ...mapGetters('ContactStore', {
      storeContacts: 'contacts'
    })
  },
  methods: {
    ...mapActions('AppStore', {
      setMeetingData: 'setMeetingData'
    }),
    ...mapActions('AuthStore', {
      logoutUser: 'logoutUser',
      updateProfileStore: 'updateProfile'
    }),
    ...mapActions('ContactStore', {
      resetContactStore: 'resetStore',
      updateContactStore: 'updateContact'
    }),
    ...mapActions('ConversationStore', {
      resetConversations: 'resetConversations'
    }),
    async getMeetingToken (meetdata) {
      // let credential = null;
      // try {
      //   if (!meetdata.meetToken) {
      //     if (!this.user) {
      //       credential = await getFreeMeetingCredentials(meetdata);
      //     } else {
      //       credential = await getMeetingCredentials(meetdata);
      //     }
      //   } else {
      //     credential = {
      //       token: meetdata.meetToken,
      //       room: meetdata.room
      //     };
      //   }
      // } catch (error) {}
      // if (credential) {
      //   const dataToMeeting = {
      //     credential,
      //     room: meetdata.room,
      //     dname: meetdata.dname
      //   };
      //   await this.setMeetingData(dataToMeeting);
      //   this.sendToControls({
      //     type: 'task',
      //     scope: 'app',
      //     data: {
      //       task: 'setMeetingData',
      //       param: dataToMeeting
      //     }
      //   });
      //   const self = this;
      //   if (this.meetingInitiated) {
      //     setTimeout(() => {
      //       self.sendToControls({
      //         type: 'input',
      //         scope: 'app',
      //         data: {
      //           field: 'showContactInfo',
      //           value: false
      //         }
      //       });
      //       self.showContactInfo = false;
      //       self.sendToControls({
      //         type: 'input',
      //         scope: 'app',
      //         data: {
      //           field: 'showingGroupInfo',
      //           value: false
      //         }
      //       });
      //       self.showingGroupInfo = false;
      //       self.sendToControls({
      //         type: 'task',
      //         scope: 'app',
      //         data: {
      //           task: 'gotoMeetingPage'
      //         }
      //       });
      //       this.sendToControls({
      //         type: 'task',
      //         scope: 'app',
      //         data: {
      //           task: 'setInMeetingStatus',
      //           param: true
      //         }
      //       });
      //       self.gotoMeetingPage();
      //     }, self.$_GLOBAL.Timers.CALL_INFO_DELAY);
      //   }
      // }
    },
    gotoMeetingPage () {
      this.$router.push({ name: 'meeting' });
    },
    async onAddToContact (contact) {
      if (contact && contact.id && this.currentContact) {
        // this.sendToControls({
        //   type: 'task',
        //   scope: 'app',
        //   data: {
        //     task: 'onAddToContact',
        //     param: contact
        //   }
        // });
        const found = this.storeContacts.find(elem => {
          return elem.id === contact.id;
        });
        if (found) {
          this.currentContact = found;
        }
      }
    },
    async onAddToFav (contact) {
      if (
        contact &&
        contact.id &&
        this.currentContact &&
        this.currentContact.id &&
        this.currentContact.id === contact.id
      ) {
        // this.sendToControls({
        //   type: 'task',
        //   scope: 'app',
        //   data: {
        //     task: 'onAddToFav',
        //     param: contact
        //   }
        // });
        this.currentContact.isfav = true;
      }
    },
    onAppReady () {
      this.appReady();
    },
    onCallAccept ({ authorized, room, callid }) {
      const msg = {
        callid: callid,
        authorized: !!authorized
      };
      if (room) {
        msg.room = room;
      } else {
        msg.room = this.user.room;
      }
      this.$refs.presenceServer.acceptcall(msg);
    },
    onEndCall ({ userhash }) {
      const msg = {
        callid: this.currentOutgoingContact.callid,
        toid: userhash,
        client: 'presence'
      };
      if (this.user) {
        this.$refs.presenceServer.endcall(msg);
      } else {
        this.onExitMeeting();
      }
      // this.sendToControls({
      //   type: 'task',
      //   scope: 'app',
      //   data: {
      //     task: 'updateOutgoingContact',
      //     param: { callstatus: 'end' }
      //   }
      // });
      this.updateOutgoingContact({ callstatus: 'end' });
    },
    onCallReject ({ room, callid, reason }) {
      const msg = {};
      if (callid) {
        msg.callid = callid;
      }
      if (room) {
        msg.room = room;
      }
      if (reason) {
        msg.reason = room;
      }
      this.$refs.presenceServer.rejectcall(msg);
    },
    onChangeDomain (appURL) {
      this.$_NATIVE.reloadApp({
        appurl: appURL
      });
    },
    async onChangeLanguage (lang, noUpdate) {
      try {
        await loadLanguageAsync(lang);
        this.sendToControls({
          type: 'task',
          scope: 'app',
          data: {
            task: 'updateLanguageLocal',
            param: {
              locale: this.$i18n.locale,
              messages: this.$i18n.messages[this.$i18n.locale]
            }
          }
        });
      } catch (error) {}
      if (this.user && !noUpdate) {
        try {
          await updateProfile({
            defaultlanguage: this.$i18n.locale
          });
          await this.updateProfile({
            defaultlanguage: this.$i18n.locale
          });
        } catch (error) {}
      }
    },
    onConnectPresence () {
      this.connectPresence();
    },
    onFetchRecentCalls () {
      if (this.user && !this.user.supereasymode) {
        this.$refs.presenceServer.getRecentCalls();
      }
    },
    async onGotoWebrtcPage (data) {
      if (data.iscustom) {
        data.isendpoint = true;
        data.protocol = 'presence';
        data.userhash = this.getDefaultDevice(data.devices);
        data.room = data.userhash;
      }
      this.$router.push({
        name: 'freeclient',
        params: {
          room: data.room,
          exitUrl: `${this.$_CONFIG.baseurl}${this.isDesktopApp ? 'desktop' : ''}`,
          user: data
        }
      });
    },
    async onGotoWebrtcPageFromDeeplink ({ room, dname, pin }) {
      this.$router.push({
        name: 'freeclient',
        params: {
          room,
          dname,
          pin,
          exitUrl: `${this.$_CONFIG.baseurl}${this.isDesktopApp ? 'desktop' : ''}`
        }
      });
    },
    onHidePairingScreen () {
      this.showPairing = false;
    },
    onHideToast () {
      // this.sendToControls({
      //   type: 'task',
      //   scope: 'app',
      //   data: {
      //     task: 'onHideToast'
      //   }
      // });
      this.hideToast();
    },
    onJoinMeeting (calldata) {
      const meetData = {
        room: calldata.room,
        dname: calldata.dname,
        bandwidth: this.bandwidth,
        meetToken: calldata.meetToken,
        authorized: !!calldata.authorized
      };
      if (calldata.protocol) {
        meetData.protocol = calldata.protocol;
      }
      this.meetingInitiated = true;
      this.getMeetingToken(meetData);
    },
    onLogout () {
      // this.sendToControls({
      //   type: 'task',
      //   scope: 'app',
      //   data: {
      //     task: 'logoutUser'
      //   }
      // });
      this.logoutUser();
      this.$refs.presenceServer.logout();
      this.disconnectPresence();
      this.resetLoginData();
      this.gotoLanding();
    },
    onMakeCall (contact) {
      const number =
        contact.alias || (contact.userhash ? contact.userhash : contact.room);
      this.$refs.presenceServer.call(number, !!contact.isendpoint);
    },
    onMakeFreeCall (contact) {
      if (this.showOutgoing) {
        this.onJoinMeeting({
          room: contact.room,
          dname: this.deviceInfo.deviceName,
          bandwidth: this.bandwidth,
          authorized: false,
          protocol: 'webrtc'
        });
      }
    },
    onRemoveCallingScreen ({ noDelay, enableAutoRotate }) {
      if (this.showIncoming) {
        this.hideIncoming(noDelay);
      }
      if (this.showOutgoing) {
        this.hideOutgoing(noDelay);
      }
      if (enableAutoRotate) {
        this.$_NATIVE.enableAutoRotate();
      }
    },
    async onRemoveContact (contact) {
      if (
        contact &&
        contact.id &&
        this.currentContact &&
        this.currentContact.id &&
        this.currentContact.id === contact.id
      ) {
        // this.sendToControls({
        //   type: 'task',
        //   scope: 'app',
        //   data: {
        //     task: 'onRemoveContact',
        //     param: contact
        //   }
        // });
        this.currentContact.id = null;
        this.currentContact.isMyContact = false;
        this.currentContact.isfav = false;
      }
    },
    async onRemoveFav (contact) {
      if (
        contact &&
        contact.id &&
        this.currentContact &&
        this.currentContact.id &&
        this.currentContact.id === contact.id
      ) {
        // this.sendToControls({
        //   type: 'task',
        //   scope: 'app',
        //   data: {
        //     task: 'onRemoveFav',
        //     param: contact
        //   }
        // });
        this.currentContact.isfav = false;
      }
    },
    onShowContactInfo (data, fromControl) {
      if (data.contact) {
        this.currentContact = data.contact;
      } else {
        this.currentContact = data;
      }
      this.showContactInfo = true;
    },
    onShowGroupInfo (data, fromControl) {
      // if (!fromControl) {
      //   this.sendToControls({
      //     type: 'task',
      //     scope: 'app',
      //     data: {
      //       task: 'onShowGroupInfo',
      //       param: data
      //     }
      //   });
      // }
      this.showingGroupInfo = true;
    },
    getDefaultDevice (devs) {
      var defdev = null;
      var devices = devs || [];
      for (var i = 0; i < devices.length; i++) {
        if (devices[i].isdefault) {
          defdev = devices[i].number;
          break;
        }
      }
      if (!defdev && devices.length > 0) {
        defdev = devices[0].number;
      }
      return defdev;
    },
    onShowOutgoingCall (data, fromControl) {
      this.exitMeetingInQueue = false;
      // if (!fromControl) {
      //   this.sendToControls({
      //     type: 'task',
      //     scope: 'app',
      //     data: {
      //       task: 'onShowOutgoingCall',
      //       param: data
      //     }
      //   });
      // }
      if (!this.inPhoneCall) {
        if (data.iscustom) {
          data.isendpoint = true;
          data.protocol = 'presence';
          data.userhash = this.getDefaultDevice(data.devices);
        }
        this.setOutgoingContact({ ...data, callstatus: 'initiated' });
        this.showOutgoing = true;
      }
    },
    onShowPairingScreen () {
      this.showPairing = true;
    },
    onShowToast (options) {
      // this.sendToControls({
      //   type: 'task',
      //   scope: 'app',
      //   data: {
      //     task: 'onShowToast',
      //     param: options
      //   }
      // });
      this.showToast(options);
    },
    onUserOffline () {
      this.$refs.presenceServer.stopdinging();
    },
    onUserOnline () {
      this.$refs.presenceServer.startdinging();
    },
    resetLoginData () {
      // this.sendToControls({
      //   type: 'task',
      //   scope: 'app',
      //   data: {
      //     task: 'resetContactStore'
      //   }
      // });
      this.resetContactStore();
      this.resetConversations();
    },
    subscribeAppEvents () {
      this.$eventBus.$on('add-to-contact', this.onAddToContact);
      this.$eventBus.$on('add-to-fav', this.onAddToFav);
      this.$eventBus.$on('appReady', this.onAppReady);
      this.$eventBus.$on('call-accept', this.onCallAccept);
      this.$eventBus.$on('end-call', this.onEndCall);
      this.$eventBus.$on('call-reject', this.onCallReject);
      this.$eventBus.$on('changeDomain', this.onChangeDomain);
      this.$eventBus.$on('change-language', this.onChangeLanguage);
      this.$eventBus.$on('connectPresence', this.onConnectPresence);
      this.$eventBus.$on('fetch-recent-calls', this.onFetchRecentCalls);
      this.$eventBus.$on('goto-webrtc-page', this.onGotoWebrtcPage);
      this.$eventBus.$on('goto-webrtc-page-deeplink', this.onGotoWebrtcPageFromDeeplink);
      this.$eventBus.$on('hide-pairing-screen', this.onHidePairingScreen);
      this.$eventBus.$on('hideToast', this.onHideToast);
      this.$eventBus.$on('join-meeting', this.onJoinMeeting);
      this.$eventBus.$on('logout', this.onLogout);
      this.$eventBus.$on('make-call', this.onMakeCall);
      this.$eventBus.$on('make-free-call', this.onMakeFreeCall);
      this.$eventBus.$on('remove-calling-screen', this.onRemoveCallingScreen);
      this.$eventBus.$on('remove-contact', this.onRemoveContact);
      this.$eventBus.$on('remove-fav', this.onRemoveFav);
      this.$eventBus.$on('show-contact-info', this.onShowContactInfo);
      this.$eventBus.$on('show-group-info', this.onShowGroupInfo);
      this.$eventBus.$on('set-body-height', this.setBodyHeight);
      this.$eventBus.$on('show-outgoing-screen', this.onShowOutgoingCall);
      this.$eventBus.$on('show-pairing-screen', this.onShowPairingScreen);
      this.$eventBus.$on('showToast', this.onShowToast);
      this.$eventBus.$on('update-profile-info', this.updateProfile);
      this.$eventBus.$on('update-profile-status', this.updateStatus);
      this.$eventBus.$on('userOffline', this.onUserOffline);
      this.$eventBus.$on('userOnline', this.onUserOnline);
    },
    async updateProfile (profile) {
      // this.sendToControls({
      //   type: 'task',
      //   scope: 'app',
      //   data: {
      //     task: 'updateProfileStore',
      //     param: profile
      //   }
      // });
      this.updateProfileStore(profile);
      this.$refs.presenceServer.selfMessage('profiledata', profile);
    },
    async updateStatus (status) {
      let result = null;
      try {
        result = await updateStatus(status);
      } catch (error) {}
      if (result) {
        this.$refs.presenceServer.changeStatus(status);
        const data = { status: status ? 1 : 0 };
        this.sendToControls({
          type: 'task',
          scope: 'app',
          data: {
            task: 'updateProfileStore',
            param: data
          }
        });
        this.updateProfileStore(data);
      }
    },
    unsubscribeAppEvents () {
      this.$eventBus.$off('add-to-contact', this.onAddToContact);
      this.$eventBus.$off('add-to-fav', this.onAddToFav);
      this.$eventBus.$off('appReady', this.onAppReady);
      this.$eventBus.$off('call-accept', this.onCallAccept);
      this.$eventBus.$off('end-call', this.onEndCall);
      this.$eventBus.$off('call-reject', this.onCallReject);
      this.$eventBus.$off('changeDomain', this.onChangeDomain);
      this.$eventBus.$off('change-language', this.onChangeLanguage);
      this.$eventBus.$off('connectPresence', this.onConnectPresence);
      this.$eventBus.$off('fetch-recent-calls', this.onFetchRecentCalls);
      this.$eventBus.$off('goto-webrtc-page', this.onGotoWebrtcPage);
      this.$eventBus.$off('goto-webrtc-page-deeplink', this.onGotoWebrtcPageFromDeeplink);
      this.$eventBus.$off('hide-pairing-screen', this.onHidePairingScreen);
      this.$eventBus.$off('hideToast', this.onHideToast);
      this.$eventBus.$off('join-meeting', this.onJoinMeeting);
      this.$eventBus.$off('logout', this.onLogout);
      this.$eventBus.$off('make-call', this.onMakeCall);
      this.$eventBus.$off('make-free-call', this.onMakeFreeCall);
      this.$eventBus.$off('remove-calling-screen', this.onRemoveCallingScreen);
      this.$eventBus.$off('remove-contact', this.onRemoveContact);
      this.$eventBus.$off('remove-fav', this.onRemoveFav);
      this.$eventBus.$off('show-contact-info', this.onShowContactInfo);
      this.$eventBus.$off('show-group-info', this.onShowGroupInfo);
      this.$eventBus.$off('set-body-height', this.setBodyHeight);
      this.$eventBus.$off('show-outgoing-screen', this.onShowOutgoingCall);
      this.$eventBus.$off('show-pairing-screen', this.onShowPairingScreen);
      this.$eventBus.$off('showToast', this.onShowToast);
      this.$eventBus.$off('update-profile-info', this.updateProfile);
      this.$eventBus.$off('update-profile-status', this.updateStatus);
      this.$eventBus.$off('userOffline', this.onUserOffline);
      this.$eventBus.$off('userOnline', this.onUserOnline);
    }
  }
};
